import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { ColorModeScript } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { useErrorBoundary: true },
  },
});

root.render(
  <React.Suspense fallback="loading">
    <QueryClientProvider client={queryClient}>
      <Auth0Provider
        domain={window.ENV_CONFIG.auth0.domain}
        clientId={window.ENV_CONFIG.auth0.client_id}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: window.ENV_CONFIG.auth0.audience,
        }}
      >
        <App />
        <ColorModeScript />
      </Auth0Provider>
    </QueryClientProvider>
  </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
